import Actor from './actor'

/**
 * Creates a new record
 */
class NewRecordActor extends Actor {

	act() {
		this.options.formDirector.setPreviousRecord(null)
		this.options.formDirector.setRecord(null)
		this.options.formDirector.render()
	}

}

export default NewRecordActor

NewRecordActor.__filename__ = 'forms/actions/new-record-actor.js'
